<template>
    <div class="section">
        <div class="section-header" v-if="title && title.length > 0">
            <div class="section-mark">
                <img src="@/assets/img/section-icon.png" alt="" />
            </div>
            <div class="section-title">
                {{ title }}
            </div>
            <slot name="header"></slot>
        </div>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>
<script type="text/javascript">
export default {
    name: 'create-sections',
    components: {},
    computed: {},
    data () {
        return {
        }
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        tipType: {
            type: String,
            default: ''
        },
        mColor: {
            type: String,
            default: '#46CDCF'
        }
    },
    mounted () {},
    methods: {}
}
</script>
<style lang="scss" scoped>
.section {
    position: relative;
    background-color: white;
    margin-top: 8px;
}
.section:first-child {
    margin-top: 0;
}

.section-mark {
    height: 14px;
}

.section-header {
    display: flex;
    align-items: center;
    padding: 5px 0;
}
.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-left: 8px;
    flex-shrink: 0;
}

.content {
    padding: 0px 10px 0 10px;
}
</style>
